export const getOS = (): string => {
  if (navigator.userAgent.indexOf('Window') > 0) {
    return 'win';
  } else if (navigator.userAgent.indexOf('Mac OS X') > 0) {
    return 'mac';
  } else if (navigator.userAgent.indexOf('CrOS') > 0) {
    return 'cros';
  } else {
    return '';
  }
};
